import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const WarningMessage = styled.span`
    width: 100%;
    margin: 10px 0;
    font: ${theme.font.body[1]};
    letter-spacing: 0px;
    color: ${(props) => props.theme.grey};
`;
